module.exports = __webpack_public_path__ + "img/Flag.fb18768a.svg";